// Copyright (c) 2022 by Move Closer

import { CartIdentifier } from '../../../contexts'

export interface IAnalyticsRepository {
  initCheckout (cartId: CartIdentifier): Promise<void>
  trackProductView (productId: number): Promise<void>
  trackPageView (url: string): Promise<void>
}

export const AnalyticsRepositoryType = Symbol.for('IAnalyticsRepository')
